var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"menu2-box"},[_c('div',{staticClass:"menu2"},[_c('ul',_vm._l((_vm.menus),function(item,index){return _c('li',{key:index,class:_vm.curName == item.name ? 'activity' :''},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push(item.url)}}},[_vm._v(_vm._s(item.name))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }